module.exports = __webpack_public_path__ + "img/bottom-shadow.cbc0ea19.svg";